export default __webpack_public_path__ + "static/media/profile.aecd8ea2.svg";